import React from 'react';
import GroupCard from '@dashboard/components/GroupCard';
import { resolvePriceTabs } from './PriceGrouping';

/**
 * What the checkout does with the price mix, for the card's summary line: the
 * rows already show which prices exist, but not whether the picker groups them
 * into tabs - that comes from the theme's grouping setting, invisible from
 * here. "Tabs by billing" / "Tabs by interval", or nothing for a flat list.
 */
export function describeGrouping(values, groupingAxis) {
  const tabs = resolvePriceTabs(values, groupingAxis);
  return tabs ? `Tabs by ${tabs.axis}` : null;
}

const PRICES_TABS = [
  { key: 'prices', label: 'Prices' },
  { key: 'settings', label: 'Settings' },
];

/**
 * The card above a multi-price product's list, the same always-open card as an
 * event's lone ticket group: the heading the customer sees (or "Prices" until
 * one is set), the price count, and the Prices / Settings tabs.
 */
export default function PricesHeaderCard({ name, priceCount, detail, activeTab, onTabChange }) {
  // "7 added", not "7 prices": the name above already reads "Prices" until the
  // seller sets a heading, and the tab below it does too.
  const summary = [`${priceCount} added`, detail].filter(Boolean).join(' • ');

  return (
    <GroupCard
      data-testid="prices-header-card"
      title={<span data-testid="prices-header-name">{name}</span>}
      summary={summary}
      tabs={PRICES_TABS}
      activeTab={activeTab}
      onTabChange={onTabChange}
    />
  );
}
